module.exports = __webpack_public_path__ + "img/nz.05d3bd4.webp";